import { Component, OnInit, ViewChild } from '@angular/core';
import { LoaderComponent } from '../../../loader/loader.component';
import { CommonModule } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { SalesService } from '../../../../services/sales.service';
import { Product, RecentInteractions, SalesOrder, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { Table } from 'primeng/table';
import { CustomerService } from '../../../../services/customer.service';
import { catchError, firstValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { ReportCenterService } from '../../../../services/report-center.service';
import { environment } from '../../../../../environments/environment';
import { InventoryService } from '../../../../services/inventory.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { OrderLookupComponent } from '../../../Lookup/order-lookup/order-lookup.component';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';

@Component({
  selector: 'app-order-list',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './order-list.component.html',
  styleUrl: './order-list.component.scss'
})
export class OrderListComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  paginator: boolean | undefined;

  constructor(
    private router: Router,
    private salesService: SalesService,
    private confirmationService: ConfirmationService,
    private customerService: CustomerService,
    private messageService: MessageService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private emailTemplateService: EmailTemplateService,
    private reportService : ReportCenterService,
    private inventoryService: InventoryService,
    private administratorService: AdministratorService,
    private porderservice: PurchaseorderService
  ) { }

  loader: boolean = false;
  searchKey: any;
  listOrder: SalesOrder[] = [];
  selectedOrder: SalesOrder[] = [];
  shiptocustomername: any;
  Data: any;
  companyInfo: any = {};
  ReportPath: any;
  OrderNumber: any;
  Status: any;
 products: Product[] = [];    
  allProductData: Product[] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  ngOnInit(): void {
    document.title = 'Order List ';
    this.getOrderList();
    this.getCompanyDetails();
    this.searchEffect();
  }

  create() {
    this.router.navigate(['/home/createOrder']);
  }

  loadOrderList(event:any){
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchOrder();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getOrderList();
    }
  }

  getOrderList() {
    // this.loader = true;
    this.salesService.getSalesOrderByStatus('ORDER', this.pageRequest).subscribe(
      (data: any) => {
        if (data) {
          this.listOrder = data.salesOrder;
          // this.loader = false;
        } else {
          console.log(data);
          // this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        // this.loader = false;
      }
    );
  }

  edit(data?: any) {
    if(data){
      this.router.navigate(['/home/createOrder'], {queryParams: { 'Data': data.salesOrderId },skipLocationChange: false,});
    }else{
      const Data = JSON.stringify(this.selectedOrder[0].salesOrderId);
      this.router.navigate(['/home/createOrder'], {queryParams: { 'Data': Data },skipLocationChange: false,});
    }
  }

async deleteQuote() {
  this.confirmationService.confirm({
    header: 'Are you sure?',
    message: 'Please confirm to proceed.',
    accept: async () => {
      this.loader = true;

      try {
        const deleteTasks = this.selectedOrder.map(async (orderRaw) => {
          const order: SalesOrder = this.mapToSalesOrder(orderRaw);
          const salesOrderId = order.salesOrderId;
          const salesOrderNumber = order.SalesOrderNumber;
          const warehouseId = order.WarehouseId;

          let lineItemData: any[] = [];
          try {
            lineItemData = await firstValueFrom(
              this.salesService.getSalesOrderLineItem(salesOrderNumber)
            );
          } catch (err) {
            console.error(`Failed to get line items for ${salesOrderNumber}:`, err);
          }

          try {
            await firstValueFrom(this.salesService.deleteSalesOrder([salesOrderId]));
          } catch (delErr) {
            console.error(`Failed to delete order ${salesOrderNumber}:`, delErr);
            return; // skip inventory update if deletion fails
          }

          try {
            const lineItemIds = lineItemData.map(item => item.salesOrderLineItemId);
            if (lineItemIds.length) {
              await firstValueFrom(
                this.salesService.deleteSalesOrderLineItem(lineItemIds)
              );
            }
          } catch (err) {
            console.error(`Failed to delete line items for ${salesOrderNumber}:`, err);
          }
          const inventoryTasks = lineItemData.map(product => {
            const inventory: UpdateInventory = {
              productId: product.productId,
              warehouseId: _.toNumber(warehouseId),
              productCode: product.productCode,
              status: "DirectOrder",
              transactionNo: salesOrderNumber,
              transactionType: "",
              quantity: product.orderQuantity,
              createdBy: localStorage.getItem('username') || '',
              transactionDate: new Date(),
              createdDate: new Date(),
            };
            return firstValueFrom(this.inventoryService.updateInventoryNew(inventory));
          });

          try {
            await Promise.all(inventoryTasks);
          } catch (invErr) {
            console.error(`Inventory update failed for order ${salesOrderNumber}:`, invErr);
          }
        });

        await Promise.all(deleteTasks);

        this.products = [];
        this.allProductData = [];

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Deleted successfully.'
        });
        this.selectedOrder = [];
        
        this.searchKey = '';
        this.paginator = true;
        this.pageRequest.pageIndex = 0;
        this.pageRequest.pageSize = 50;

        if (this.dt1) {
          this.dt1.first = 0;
        }

        await this.getOrderList();
      } catch (error) {
        console.error('Unexpected error during deleteQuote:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete selected orders.'
        });
      } finally {
        this.loader = false;
      }
    },
    reject: () => {
      // User cancelled
    }
  });
}

  mapToSalesOrder(order: any): SalesOrder {
    return {
      salesOrderId: order.salesOrderId,
      SalesOrderNumber: order.salesOrderNumber || order.SalesOrderNumber,
      OrderType: order.orderType || order.OrderType,
      CustomerId: order.customerId?.toString() || order.CustomerId,
      SalesOrderDate: new Date(order.salesOrderDate || order.SalesOrderDate),
      SalesOrderInvoiceDate: new Date(order.salesOrderInvoiceDate || order.SalesOrderInvoiceDate || new Date()),
      ShipmentDate: new Date(order.shipmentDate || order.ShipmentDate || new Date()),
      SalespersonId: order.salespersonId?.toString() || order.SalespersonId,
      SalespersonCode: order.salespersonCode || order.SalespersonCode,
      BillToCustomerId: order.billToCustomerId?.toString() || order.BillToCustomerId,
      ShipToCustomerId: order.shipToCustomerId?.toString() || order.ShipToCustomerId,
      BillToCustomerCode: order.billToCustomerCode || order.BillToCustomerCode,
      ShipToCustomerCode: order.shipToCustomerCode || order.ShipToCustomerCode,
      QuoteExpiration: order.quoteExpiration ? new Date(order.quoteExpiration) : new Date(),
      WarehouseId: order.warehouseId?.toString() || order.WarehouseId,
      PurchaseOrderNumber: order.purchaseOrderNumber || order.PurchaseOrderNumber,
      OrderTotal: order.orderTotal || order.OrderTotal,
      CGSTTotal: order.cgstTotal || order.CGSTTotal,
      SGSTTotal: order.sgstTotal || order.SGSTTotal,
      IGSTTotal: order.igstTotal || order.IGSTTotal,
      totalWeight: order.totalWeight || order.totalWeight,
      DispatchDocNo: order.dispatchDocNo || order.DispatchDocNo,
      ShippingStatus: order.shippingStatus || order.ShippingStatus,
      SalesOrderStatus: order.salesOrderStatus || order.SalesOrderStatus,
      BackOrderStatus: order.backOrderStatus || order.BackOrderStatus,
      SalesTaxTotal: order.salesTaxTotal || order.SalesTaxTotal,
      MarginTotal: order.marginTotal || order.MarginTotal,
      ProfitTotal: order.profitTotal || order.ProfitTotal,
      LabourTotal: order.labourTotal || order.LabourTotal,
      FreightTotal: order.freightTotal || order.FreightTotal,
      IsGlPosted: order.isGlPosted || order.IsGlPosted,
      InvoiceYear: order.invoiceYear || order.InvoiceYear,
      InvoiceMonth: order.invoiceMonth || order.InvoiceMonth,
      BackOrderTotal: order.backOrderTotal || order.BackOrderTotal,
      GLError: order.glError || order.GLError,
      IsLabourTaxable: order.isLabourTaxable || order.IsLabourTaxable,
      IsFreightTaxable: order.isFreightTaxable || order.IsFreightTaxable,
      IsActive: order.isActive || order.IsActive,
      CreatedBy: order.createdBy || order.CreatedBy,
      UpdatedBy: order.updatedBy || order.UpdatedBy,
      TermsCode: order.termsCode || order.TermsCode,
      PaymentTermsId: order.paymentTermsId || order.PaymentTermsId,
      MotorVehicleNo: order.motorVehicleNo || order.MotorVehicleNo,
      BillOfLading: order.billOfLading || order.BillOfLading,
      LRRRNo: order.lrrrNo || order.LRRRNo,
      DispatchThrough: order.dispatchThrough || order.DispatchThrough,
      orderDate: new Date(order.orderDate || order.orderDate),
      requestedDate: new Date(order.requestedDate || order.requestedDate),
      deliveryNote: order.deliveryNote || order.DeliveryNote,
      ServiceCallCode: order.serviceCallCode || order.ServiceCallCode,
      ReferenceNumber: order.referenceNumber || order.ReferenceNumber,
      Destination: order.destination || order.Destination,
      TermsOfDelivery: order.termsOfDelivery || order.TermsOfDelivery,
      Status: order.status || order.Status,
      CustomerPODate:  order.customerPODate ? new Date(order.customerPODate) : new Date(),
      driverName: order.driverName,
      driverContact: order.driverContact,
      expDeliveryDate:  order.expDeliveryDate ? new Date(order.expDeliveryDate) : new Date(),
    };
  };

  searchOrder() {
    if (!this.searchKey) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    // this.loader = true;

    this.salesService.SearchSalesOrder(this.searchKey).subscribe(
      (data: any) => {
        console.log('Response from SalesService:', data);

        if (Array.isArray(data)) {
          this.listOrder = data.filter((order: any) => order.salesOrderStatus === 'ORDER');
          this.pageRequest.pageSize = this.listOrder.length;
          this.paginator = false;
        }
        else if (data && Array.isArray(data.salesOrder)) {
          this.listOrder = data.salesOrder.filter((order: any) => order.salesOrderStatus === 'ORDER');
          this.pageRequest.pageSize = this.listOrder.length;
          this.paginator = false;
        }
        else {
          this.listOrder = [];
          console.warn('No sales orders found or incorrect format', data);
        }

        // this.loader = false;
      },
      (error) => {
        console.error('Search error:', error);
        // this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
      }
    );
  }


// showReport(value: any): void {
//   const formCode = 'Order';
//   this.reportService.getReportName(formCode).subscribe({
//     next: (report: any) => {
//       const orderNumber = value.salesOrderNumber;
//       const sanitizedOrderNumber = orderNumber.replace(/[^a-zA-Z0-9]/g, "_");
//       document.title = sanitizedOrderNumber;
//       this.ref = this.dialogService.open(ReportLookupComponent, {
//         header: report.formName,
//         width: '100%',
//         data: {
//           OrderNo: orderNumber,
//           ReportName: sanitizedOrderNumber,  
//           ReportPath: report.path
//         }
//       });
//       this.ref.onClose.subscribe(() => {
//         this.searchKey = '';
//         document.title = 'Order List'; 
//       });
//     },
//     error: (err) => {
//       console.error('Report not found for form code:', formCode, err);
//     }
//   });
// } 

  showReport(salesOrderNumber: any) {
    this.ref = this.dialogService.open(OrderLookupComponent, { 
      header: 'Sales Order Reports', 
      width: '50%', 
      data: { salesOrderNumber: salesOrderNumber } 
    });
  }


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getOrderList();
    this.selectedOrder = [];
  }

  sendOrderEmail(value?: any) {
    if (!this.selectedOrder || this.selectedOrder.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select at least one order' });
      return;
    }

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    const tenant = auth.tenant.tenantCode;

    const formCode = `Order`;
    this.loader = true;
    const totalOrders = this.selectedOrder.length;
    let successCount = 0;
    let skippedCount = 0;
    let processedCount = 0;

    this.getUserDepartmentName().subscribe(departmentName => {

    this.selectedOrder.forEach(order => {

      this.reportService.getReportName(formCode).pipe(

        switchMap((report: any) => {
          if (!report?.path) {
            throw new Error('REPORT_MISSING');
          }
          const reportPath = report.path;

          return this.salesService.getSalesOrderById(order.salesOrderId).pipe(
            map(orderData => ({ orderData, reportPath }))

          );
        }),

        switchMap(({ orderData, reportPath }) => {

          if (!orderData?.customer?.email) {
            throw new Error('EMAIL_MISSING');
          }
          return this.customerService.getCustomerById(orderData.shipToCustomerId).pipe(
            map(shipToCustomer => ({ orderData, shipToCustomer, reportPath }))

          );
        }),

        switchMap(({ orderData, shipToCustomer, reportPath }) => {

          return this.emailTemplateService.getTemplate('order-email-template').pipe(
            map(template => {

              if (!template) {
                throw new Error('TEMPLATE_MISSING');
              }

              const formatCurrency = (value: number) =>
                `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

              const templateData = {
                customerName: orderData.customer.customerName,
                orderNumber: orderData.salesOrderNumber,
                orderDate: new Date(orderData.orderDate).toLocaleDateString(),
                shipToName: shipToCustomer?.customerName || 'N/A',
                salespersonName: orderData.salesperson.salespersonName,
                salespersonCode: orderData.salesperson.salespersonCode,
                warehouseName: orderData.warehouse.warehouseName,
                orderTotal: formatCurrency(orderData.orderTotal),
                cgstTotal: formatCurrency(orderData.cgstTotal),
                sgstTotal: formatCurrency(orderData.sgstTotal),
                igstTotal: formatCurrency(orderData.igstTotal),
                salesTaxTotal: formatCurrency(orderData.salesTaxTotal),
                currentYear: new Date().getFullYear(),
                companyName: this.companyInfo?.companyName || '',
                companyEmail: this.companyInfo?.companyEmail || '',
                companyPhone: this.companyInfo?.companyPhone || '',
                companyWebsite: this.companyInfo?.companyWebsite || ''
              };

              return {
                orderData,
                emailBody: this.emailTemplateService.replacePlaceholders(template, templateData),
                reportPath
              };
            })
          );
        }),

        switchMap(({ orderData, emailBody, reportPath }) => {

          const emailData = {
            EmailToId: orderData.customer.email,
            EmailToName: orderData.customer.customerName,
            EmailSubject: `Order ${orderData.salesOrderNumber} from ${this.companyInfo?.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: orderData.salesOrderNumber,
            OrderType: 'SalesOrder',
            TenantId: tenant,
            ReportPath: reportPath,
            DepartmentName: departmentName 
          };

          return this.salesService.SendMail(emailData).pipe(
            map(response => ({
              response,
              orderData 
            }))
          );
        }),


        catchError(err => {
          console.error('Email skipped:', err.message);
          return of(null);
        })

      ).subscribe({
        next: (result) => {

          if (result !== null) {
            successCount++;
            this.createRecentInteractions(result.orderData, departmentName);
          }

          processedCount++;

          if (processedCount === totalOrders) {
            this.loader = false;

            if (successCount === 0) {
              this.messageService.add({
                severity: 'warn',
                summary: 'No Emails Sent',
                detail: 'Emails were not sent because required data (report / email / template) was missing.'
              });

              this.selectedOrder = [];
            }
            else if (successCount < totalOrders) {
              this.messageService.add({
                severity: 'warn',
                summary: 'Partial Success',
                detail: `${successCount} email(s) sent. ${skippedCount} skipped due to validation issues.`
              });

              this.selectedOrder = [];
            }
            else {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Successfully sent ${successCount} email(s).`
              });
            }
            this.selectedOrder = [];
          }
        }
        ,
        error: () => {
          processedCount++;
          if (processedCount === totalOrders) {
            this.loader = false;
            this.messageService.add({
              severity: 'warn',
              summary: 'Warning',
              detail: 'Some emails failed to send. Please try again.'
            });
          }
        }
      });
    });
   });
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  createRecentInteractions(orderData: any, departmentName: string = '') {
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: 'Send Mail',
          from: fromEmail,
          to: orderData.customer.email || 'default@example.com',
          subject: `Order ${orderData.salesOrderNumber} ${orderData.status || ''}`,
          customerNumber: orderData.customer.customerCode,
          description: 'Order email sent successfully',
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => console.log('Recent interaction created:', res),
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }


  placeholder: string = 'Search By ';
  private messages: string[] = ['Order No',	'Order Date',	'Bill To Customer',	'Ship To Customer',	'Order Total', 'Reqd Date'];    private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

  statusColors: { [key: string]: string } = {
    'Draft - 0%': '#28a745',
    'Confirmed - 20%': '#007bff',
    'Processing - 40%': '#ff9800',
    'Released to Fulfillment - 60%': '#6f42c1',
  };


  getStatusColor(status: string): string {
    return this.statusColors[status] || 'black';
  }


  getDisplayStatus(status: string): string {
    if (!status) return '';
    const index = status.indexOf(' - ');
    return index !== -1 ? status.substring(0, index) : status;
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.administratorService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }
}
